import { useState, useEffect, useCallback } from "react";
import { supabase } from "../lib/supabase";

export const useLocations = (activeOnly = true) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadLocations = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      let query = supabase
        .from("locations")
        .select("*")
        .order("order_index", { ascending: true });

      // Filter for active locations if requested
      if (activeOnly) {
        query = query.eq("is_active", true);
      }

      const { data, error } = await query;

      if (error) throw error;

      setLocations(data || []);
    } catch (err) {
      console.error("Error loading locations:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [activeOnly]);

  useEffect(() => {
    loadLocations();
  }, [activeOnly, loadLocations]);

  const refreshLocations = () => {
    loadLocations();
  };

  // Helper function to get location by ID
  const getLocationById = (locationId) => {
    return locations.find(location => location.id === locationId) || null;
  };

  // Helper function to format location for display
  const formatLocationInfo = (location) => {
    if (!location) return "Locație nespecificată";
    
    let info = location.title;
    if (location.schedule) {
      info += ` • ${location.schedule}`;
    }
    if (location.phone) {
      info += ` • ${location.phone}`;
    }
    
    return info;
  };

  return {
    locations,
    loading,
    error,
    refreshLocations,
    getLocationById,
    formatLocationInfo
  };
}; 